import { component, prop } from '../../../decorators';

import FilterInput from '../filter-input/filter-input.vue';
import Range from '../range/range.vue';
import TranscriptItem from './transcript-item/transcript-item.vue';

import { classList, scrollIntoViewIfNeeded } from '../utils';

import findIndex from 'lodash/findIndex';
import inRange from 'lodash/inRange';

const DEFAULT_IDX = -1;
const ZERO = 0;

@component({
   name: 'Transcript',
   components: { FilterInput, Range, TranscriptItem },
   watch: {
      currentMark: 'refreshMark',
      currentTime: 'onChangeTime',
      list: 'onLoad'
   }
})
export default class Transcript {
   search         = ''
   currentIndex   = DEFAULT_IDX
   marksCount     = ZERO
   currentMark    = ZERO

   @prop({ type: Array, required: true }) list
   @prop({ type: Number, required: true }) currentTime
   @prop({ }) selected

   get rangeMark() {
      return this.marksCount ? increment(this.currentMark) : this.marksCount;
   }

   onEnter() {
      this.currentMark = ++this.currentMark === this.marksCount ? ZERO : this.currentMark;
      this._selectMarked();
   }

   goto(item) {
      this.$emit('click', item);
   }

   refreshMark() {
      const marks = this.$el.querySelectorAll('mark');
      let currentMark = this.$el.querySelector('mark.current');
      if (currentMark) {
         classList(currentMark).remove('current');
      }

      currentMark = marks[this.currentMark];

      if (currentMark) {
         classList(currentMark).add('current');
         scrollIntoViewIfNeeded(currentMark);
      }
   }

   onChangeTime() {
      // const ms = time * MS_IN_SEC;
      const time = Math.ceil(this.currentTime);
      this.currentIndex = findIndex(this.list, item => inRange(time, item.from, item.to));
      const items = this.$el.querySelectorAll('.transcript__item');
      scrollIntoViewIfNeeded(items[this.currentIndex]);
   }

   refreshSearch(search) {
      this.currentMark = 0;
      this.search = search;

      if (search === '') {
         this.marksCount = 0;
         return;
      }

      this.$nextTick(() => {
         const _reducer = (memo, component) => memo + (component.countOfMatches || ZERO);
         this.marksCount = this.$refs.items.reduce(_reducer, ZERO);
         this.$nextTick(this.refreshMark);
      });
   }

   _selectMarked() {
      setTimeout(() => {
         let currentMark = this.$el.querySelector('mark.current');
         if (currentMark) {
            currentMark.click();
         }
      });
   }

   changeCurrentMark(mark) {
      this.currentMark = decrement(mark);
      this.$nextTick(this.refreshMark);
      this._selectMarked();
   }

   onLoad() {
      this.refreshSearch('');
      this.$nextTick(this.onChangeTime);
   }

   mounted() {
      this.onLoad();
   }
}

function increment(i) {
   return ++i;
}

function decrement(i) {
   return --i;
}
